/****************************************************************************************
 * File Name    : FilterProcessWorkSheet.vue
 * Function     : 필터 공정순회 점검일지 - 일지작성
 * Author       : 
 * Description  : 공정순회 점검 일지 작성 및 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title="필터 공정순회 점검일지 - 일지작성" />
                </div>
            </a-col>
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box div_action">
                    <a-select :key="templateList.length" v-model="selectedTemplate" placeholder="템플릿 선택" style="width: 200px; margin-right: 10px;">
                        <a-select-option v-for="template in templateList" :key="template.id" :value="template.id">
                            {{ template.name }}
                        </a-select-option>
                    </a-select>
                    <span class='icon_button' @click="loadTemplate()">
                        <a-tag color="#2980B9" style="cursor:pointer;">
                            <a-icon type="plus-circle" /> 불러오기
                        </a-tag>
                    </span>
                </div>
            </a-col>
        </a-row>
        <a-divider type='horizontal' />
        
        <a-space align="end">
            <a-statistic title="작성중" :value="workingCount" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="question-circle" />
                </template>
            </a-statistic>
            <a-statistic title="작성완료" :value="completedCount" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="exclamation-circle" />
                </template>
            </a-statistic>
        </a-space>
        <p/>
        <a-progress type='line' :percent="90" strokeColor='#C7C6C6'/>
        <p/>
        
        <!-- 작성중 목록 -->
        <a-table :columns="columns" size="small" :bordered="false" :data-source="workingData" :scroll="{ x: 0, y: '37vh' }">
            <span slot="tags" slot-scope="tags">
                <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                    {{ tag.toUpperCase() }}
                </a-tag>
            </span>
            <span slot="name" slot-scope="text">{{ text }}</span>
            <span slot="action" slot-scope="record">
                <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                <a-divider type="vertical" />
                <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
            </span>
        </a-table>
        <p/>
        
        <!-- 작성완료 목록 -->
        <a-form class="" layout="vertical">
            <a-card>
                <a-space align="end">
                    공정순회 점검일지 조회
                    <a-input default-value="" v-model="filterCS">
                        <a-select slot="addonAfter" default-value="라인명" v-model="filterField">
                            <a-select-option value="라인명">라인명</a-select-option>
                            <a-select-option value="생산모델">생산모델</a-select-option>
                            <a-select-option value="작성자">작성자</a-select-option>
                        </a-select>
                    </a-input>
                    일자 조회
                    <date-picker v-model="filterDateStartCS" valueType="format" style="width:120px;"></date-picker> ~
                    <date-picker v-model="filterDateEndCS" valueType="format" style="width:120px;"></date-picker>
                    <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetCSList">초기화</a-button>
                </a-space>
                <p/>
                <a-table :columns="columns2" size="small" :bordered="false" :data-source="completedData" :pagination="pagination" :scroll="{ x: 0, y: '57vh' }" @change="handleTableChange">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="record">
                        <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                        <a-divider type="vertical" />
                    </span>
                </a-table>
            </a-card>
        </a-form>

        <!-- 일지 작성 Drawer -->
        <a-drawer 
            title="공정순회 점검일지 작성" 
            placement="right" 
            :closable="true" 
            :visible="flagForDrawer" 
            @close="handlerForCloseDrawer" 
            width="100%"
        >
            <a-form layout="vertical">
                <!-- 기본정보 -->
                <a-card title="기본정보" :bordered="false" style="margin-bottom: 16px;">
                    <a-descriptions bordered :column="2">
                        <a-descriptions-item label="라인명">
                            <a-input v-model="formData.basicInfo.lineName" />
                        </a-descriptions-item>
                        <a-descriptions-item label="작성자">
                            <a-input v-model="formData.basicInfo.writer" />
                        </a-descriptions-item>
                        <a-descriptions-item label="생산 모델">
                            <a-input v-model="formData.basicInfo.productModel" />
                        </a-descriptions-item>
                        <a-descriptions-item label="일자/시간">
                            <a-input :value="formData.basicInfo.dateTime" :read-only="true" style="background:#f5f5f5; cursor:default;" />
                        </a-descriptions-item>
                        <a-descriptions-item label="작성자 서명">
                            <div style="display:inline-block; border:1px dashed #d9d9d9; padding:2px 8px; min-width:100px; min-height:36px; text-align:center; vertical-align:middle;">
                                <span v-if="!signatureImage" style="color:#bbb; line-height:30px;">(서명없음)</span>
                                <img v-if="signatureImage" :src="signatureImage" style="max-height:40px; max-width:140px; display:block;" />
                            </div>
                        </a-descriptions-item>
                    </a-descriptions>
                </a-card>

                <!-- 공정별 점검 결과 입력 -->
                <a-card title="공정별 점검 결과 입력" :bordered="false" style="margin-bottom: 16px;">
                    <div style="overflow-x: auto;">
                        <table class="fpw-table">
                            <thead>
                                <tr>
                                    <th style="width:50px;">No</th>
                                    <th style="width:130px;">공정명</th>
                                    <th>Check Point</th>
                                    <th v-for="line in formData.checkLines" :key="line.id" style="width:100px; min-width:90px;">{{ line.lineName }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(proc, pIdx) in formData.processes">
                                    <tr v-for="rowNum in (proc.rowCount || 1)" :key="`${pIdx}_${rowNum}`">
                                        <td v-if="rowNum === 1" :rowspan="proc.rowCount || 1" class="fpw-center fpw-no">{{ pIdx + 1 }}</td>
                                        <td v-if="rowNum === 1" :rowspan="proc.rowCount || 1" class="fpw-center">{{ proc.processName }}</td>
                                        <td v-if="rowNum === 1" :rowspan="proc.rowCount || 1" class="fpw-cp">{{ proc.checkPoint }}</td>
                                        <td v-for="line in formData.checkLines" :key="line.id" class="fpw-result">
                                            <a-select v-model="proc.results[line.id + '_' + rowNum]" style="width: 100%;" size="small">
                                                <a-select-option value="">-</a-select-option>
                                                <a-select-option value="">&nbsp;</a-select-option>
                                                <a-select-option value="OK">OK</a-select-option>
                                                <a-select-option value="NG">NG</a-select-option>
                                            </a-select>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </a-card>

                <a-divider />
                <div style="text-align: center;">
                    <a-button @click="handlerForCloseDrawer" style="margin-right: 8px;">취소</a-button>
                    <a-button type="default" @click="handleSaveTemp" style="margin-right: 8px;">임시저장</a-button>
                    <a-button type="primary" @click="openSignatureForComplete">작성완료</a-button>
                </div>
            </a-form>

            <SignatureModal
                :visible="signatureModalVisible"
                :initial-signature="signatureImage"
                @save="handleSignatureSave"
                @cancel="signatureModalVisible = false"
            />
        </a-drawer>
    </div>
</template>

<script>
import PageHeader from "../components/PageHeader.vue";
import SignatureModal from "../components/SignatureModal.vue";

const columns = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '작성자', dataIndex: 'writer', key: 'writer' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 200 },
];

const columns2 = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '작성자', dataIndex: 'writer', key: 'writer' },
    { title: '작성일자', dataIndex: 'date', key: 'date' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 150 },
];

export default {
    name: 'FilterProcessWorkSheet',
    components: {
        PageHeader,
        SignatureModal,
    },
    data() {
        return {
            columns,
            columns2,
            workingData: [],
            completedData: [],
            currentEditKey: null,
            workingCount: 0,
            completedCount: 0,
            templateList: [],
            selectedTemplate: null,
            filterCS: '',
            filterField: '라인명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            flagForDrawer: false,
            signatureImage: null,
            signatureModalVisible: false,
            formData: {
                basicInfo: {
                    lineName: '',
                    writer: '',
                    productModel: '',
                    dateTime: ''
                },
                processes: [],
                checkLines: []
            }
        };
    },
    mounted() {
        this.fetchTemplateList();
        this.fetchWorkSheetList();
    },
    methods: {
        fetchTemplateList() {
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/process/template/list?size=100&page=0&state=FP_B`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.templateList = response.data.data.content.map(item => ({
                            id: item.productCsSeq,
                            name: item.name
                        }));
                    }
                })
                .catch((error) => console.error(error));
        },
        fetchWorkSheetList() {
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/process/worksheet/list?size=100&page=0&state=FP_C`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.workingData = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tags: ['작성중'],
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            writer: item.manager,
                            updated: item.updated
                        }));
                        this.workingCount = this.workingData.length;
                    }
                })
                .catch((error) => console.error(error));
            
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/process/worksheet/list?size=${size}&page=${page}&state=FP_D`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.completedData = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tags: ['작성완료'],
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            writer: item.manager,
                            date: item.updated ? item.updated.split(' ')[0] : '',
                            updated: item.updated
                        }));
                        this.completedCount = response.data.data.totalElements;
                    }
                })
                .catch((error) => console.error(error));
        },
        loadTemplate() {
            if (!this.selectedTemplate) {
                this.$message.error('템플릿을 선택해주세요');
                return;
            }
            
            const postData = {
                lineName: '',
                writer: sessionStorage.getItem('user_name') || '',
                creator: sessionStorage.getItem('user_name') || 'system',
                updater: sessionStorage.getItem('user_name') || 'system'
            };
            
            this.$http.post(`${this.$store.state.nodeApiUrl}/filter/process/worksheet/copy/${this.selectedTemplate}`, postData)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success('템플릿을 불러왔습니다.');
                        this.selectedTemplate = null;
                        this.fetchWorkSheetList();
                        const newSeq = response.data.data && response.data.data.productCsSeq;
                        if (newSeq) this.handlerToEdit(newSeq);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('템플릿 불러오기에 실패했습니다.');
                });
        },
        filterCSList() {
            console.log('Filter:', this.filterField, this.filterCS);
        },
        resetCSList() {
            this.filterCS = '';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.fetchWorkSheetList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchWorkSheetList();
        },
        handlerToEdit(key) {
            this.currentEditKey = key;
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/process/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        const data = response.data.data;
                        this.formData.basicInfo.lineName = data.line || '';
                        this.formData.basicInfo.writer = data.manager || '';
                        this.formData.basicInfo.productModel = data.productModel || '';
                        this.formData.basicInfo.dateTime = data.created || '';

                        // checkLines에 id(=lineSeq) 추가
                        const checkLines = (data.checkLines || []).map(l => ({
                            ...l,
                            id: l.lineSeq
                        }));
                        this.formData.checkLines = checkLines;

                        // processes에 저장된 results 복원, rowCount 보장
                        this.formData.processes = (data.processes || []).map(p => {
                            const rowCount = p.rowCount || 1;
                            const savedResults = p.results || {};
                            // 이전 형식(results[lineId])을 새 형식(results[lineId_1])으로 마이그레이션
                            const results = {};
                            checkLines.forEach(line => {
                                for (let r = 1; r <= rowCount; r++) {
                                    const newKey = line.id + '_' + r;
                                    if (savedResults[newKey] !== undefined) {
                                        results[newKey] = savedResults[newKey];
                                    } else if (r === 1 && savedResults[line.id] !== undefined) {
                                        results[newKey] = savedResults[line.id];
                                    } else {
                                        results[newKey] = '';
                                    }
                                }
                            });
                            return { ...p, rowCount, results };
                        });

                        this.signatureImage = null;
                        this.flagForDrawer = true;
                        this.fetchSignatureData();
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('데이터 조회에 실패했습니다.');
                });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/filter/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchWorkSheetList();
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('삭제에 실패했습니다.');
                        });
                }
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
            this.currentEditKey = null;
            this.signatureImage = null;
            this.signatureModalVisible = false;
        },
        handleSaveTemp() {
            this.saveWorkSheet('FP_C');
        },
        openSignatureForComplete() {
            this.signatureModalVisible = true;
        },
        handleSignatureSave(signatureData) {
            this.signatureImage = signatureData;
            this.signatureModalVisible = false;
            this.saveSignatureToServer(signatureData);
            this.saveWorkSheet('FP_D');
        },
        saveSignatureToServer(signatureData) {
            if (!this.currentEditKey) return;
            const apiUrl = `${this.$store.state.nodeApiUrl}/product/cs/save_signature_data`;
            this.$http.post(apiUrl, {
                signatureData: signatureData,
                productCsSeq: this.currentEditKey
            }).catch((error) => {
                console.error('서명 저장 실패:', error);
            });
        },
        fetchSignatureData() {
            if (!this.currentEditKey) return;
            const apiUrl = `${this.$store.state.nodeApiUrl}/product/cs/get_signature_data?productCsSeq=${this.currentEditKey}`;
            this.$http.get(apiUrl)
                .then(response => {
                    if (response.status === 200 && response.data.code === 'success' && response.data.data) {
                        this.signatureImage = response.data.data;
                    } else {
                        this.signatureImage = null;
                    }
                })
                .catch(() => {
                    this.signatureImage = null;
                });
        },
        saveWorkSheet(state) {
            if (!this.currentEditKey) {
                this.$message.error('저장할 항목을 선택해주세요.');
                return;
            }
            
            const postData = {
                name: '공정점검 일지',
                state: state,
                lineName: this.formData.basicInfo.lineName,
                writer: this.formData.basicInfo.writer,
                updater: sessionStorage.getItem('user_name') || 'system',
                processes: this.formData.processes,
                checkLines: this.formData.checkLines
            };
            
            this.$http.put(`${this.$store.state.nodeApiUrl}/filter/process/worksheet/save/${this.currentEditKey}`, postData)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success(state === 'FP_C' ? '임시저장되었습니다.' : '작성완료되었습니다.');
                        this.handlerForCloseDrawer();
                        this.fetchWorkSheetList();
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('저장에 실패했습니다.');
                });
        }
    }
};
</script>

<style scoped>
.fpw-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}
.fpw-table th, .fpw-table td {
    border: 1px solid #d9d9d9;
    padding: 4px 8px;
    vertical-align: middle;
}
.fpw-table th {
    background: #fafafa;
    text-align: center;
    font-weight: 600;
}
.fpw-center { text-align: center; }
.fpw-no { text-align: center; color: #888; }
.fpw-cp { vertical-align: middle; }
.fpw-result { text-align: center; padding: 2px 4px; }
.state-btn {
    font-weight: bold;
    padding: 2px 8px;
}
.state-btn.red {
    background-color: #ff4d4f;
    color: white;
}
.state-btn.green {
    background-color: #52c41a;
    color: white;
}
.div_action {
    text-align: right;
}
</style>
